import React, { Component } from "react";
import { Field, ErrorMessage } from "formik";
import { DatePicker, Select } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import { Stepper } from "react-form-stepper";
import BankDeatils from "../BankDetails/BankDetails";
import Dropdown from "../../../utils/Dropdown";
import style from "./IndividualInfo.module.css";
import { 
  fetchDropdownList, 
  fetchRoomDropDownListing, 
  fetchMedSchemes,
  fetchMedSchemesPlan,
  fetchMedSchemesPlanOptions,
  fetchMedSchemesPlanSubOptions } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
const { Option } = Select;

export class IndividualInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateErr: "",
      checked: false,
      scheme: "",
      isScreenLoaded: false,
      // system_role:
      //   localStorage.getItem("USER_INFO") &&
      //   JSON.parse(localStorage.getItem("USER_INFO")).systemRole,
    };
  }
  componentDidMount = async() => {
    await this.props.fetchRoomDropDownListing();
    await this.props.fetchMedSchemes(this.state.scheme);
    if(this.props.values.medicalAidScheme){
      this.props.fetchMedSchemesPlan(this.props.values.medicalAidScheme);
    }
    
    if(this.props.values.medicalAidPlan){
      this.props.fetchMedSchemesPlanOptions(this.props.values.medicalAidPlan);
    }

    if(this.props.values.medicalAidPlanOption){
      this.props.fetchMedSchemesPlanSubOptions(this.props.values.medicalAidPlanOption);
    }
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  };

  // Date validation
  dateValidationMsg = () => {
    if (this.props.errors.dateOfBirth) {
      this.setState({
        dateErr: "Date Of Birth is required",
      });
    } else {
      this.setState({
        dateErr: "",
      });
    }
  };

  disabledDate = (current) => {
    // Can not select days after today and today
    return current && current > moment().startOf("day");
  };
  goBack = () => {
    this.props.navigateBack();
  };

  goNext = () => {
    this.props.navigateNext();
  };
  goNextStpe4 = () => {
    this.props.navigateNextStep3();
  };

  handleMedSelectChange = (event) => {
   // console.log("med select change")
    let name = event.target.name;
    let val = event.target.value;
    if(name === "medicalAidScheme" && val){
     // console.log("med scheme selected");
      this.props.fetchMedSchemesPlan(val);
    }
    
    if(name === "medicalAidPlan" && val){
     // console.log("med scheme Plan selected");
      this.props.fetchMedSchemesPlanOptions(val);
    }

    if(name === "medicalAidPlanOption" && val){
     // console.log("med scheme Plan option selected");
      this.props.fetchMedSchemesPlanSubOptions(val);
    }
  }

  handleMedSchemeSelectChange = (value, name) =>{
    //console.log("value", value);
    if(name === "medicalAidScheme" && value){
     // console.log("med scheme selected");
      this.props.fetchMedSchemesPlan(value);
    }
    if(name === "medicalAidPlan" && value){
      // console.log("med scheme selected");
      this.props.fetchMedSchemesPlanOptions(value);
     }
     if(name === "medicalAidPlanOption" && value){
       // console.log("med scheme selected");
      this.props.fetchMedSchemesPlanSubOptions(value);
      }
    this.props.setFieldValue(name, value)
  }

  render() {
    // getting dropdown list options from redux persist
    const dropdownData = this.props.dropdownListData.dropdownList;
    const roomDropDownListData = this.props.roomDropDownListData.roomDropDownList;
    const schemesDropDownListData = this.props.schemesData.schemes;
    const schemesPlanDropDownListData = this.props.schemesPlanData.schemesPlan;
    const schemesPlanOptionsDropDownListData = this.props.schemesPlanOptionsData.schemesPlanOptions;
    const schemesPlanSubOptionsDropDownListData = this.props.schemesPlanSubOptionsData.schemesPlanSubOptions;
    const isDropdownEmpty = !Object.keys(dropdownData).length;

    // getting title from dropdown json
    const titleOptions =
      dropdownData &&
      !isDropdownEmpty &&
      dropdownData.prefix.map((element, index) => (
        <option key={index} value={element.prefix_id}>
          {element.prefix_name}
        </option>
      ));

      const roomOptions = roomDropDownListData &&
      roomDropDownListData.map((element, index) => (
        <option key={index} value={element.room_id}>
          {element.room_name}
        </option>
      ));

     

    // getting Contact role from dropdown json
    const roleOptions =
      dropdownData &&
      isDropdownEmpty === false &&
      dropdownData.lk_related_party_role.filter((opt) => opt.lk_related_party_role_id !== 4 && opt.lk_related_party_role_id !== 11)
      .map((element, index) => (
        <option key={index} value={element.lk_related_party_role_id}>
          {element.role_name}
        </option>
      ));
    //getting professional service data from dropdown json
    const serviceOptions =
      dropdownData &&
      !isDropdownEmpty &&
      dropdownData.lk_professional_service.map((element, index) => (
        <option key={index} value={element.lk_professional_service_id}>
          {element.service_name}
        </option>
      ));
    // getting medical aid scheme data from dropdown json
    // const mediaclAidSchemeOptions =
    //   dropdownData &&
    //   !isDropdownEmpty &&
    //   dropdownData.lk_medical_aid.map((element, index) => (
    //     <option key={index} value={element.lk_medical_aid_id}>
    //       {element.medical_aid}
    //     </option>
    //   ));

    const mediaclAidSchemeOptions = schemesDropDownListData &&
    schemesDropDownListData.map((element, index) => (
      <option key={index} value={element.code}>
        {element.name} ({element.code})
      </option>
    ));

    
    const mediaclAidSchemePlanOptions = schemesPlanDropDownListData &&
    schemesPlanDropDownListData.map((element, index) => (
      <option key={index} value={element.code}>
       {element.name} ({element.code})
      </option>
    ));

    
    const mediaclAidSchemePlanOptionsOptions = schemesPlanOptionsDropDownListData &&
    schemesPlanOptionsDropDownListData.map((element, index) => (
      <option key={index} value={element.code}>
       {element.name} ({element.code})
      </option>
    ));
    const mediaclAidSchemePlanSubOptionsOptions = schemesPlanSubOptionsDropDownListData &&
    schemesPlanSubOptionsDropDownListData.map((element, index) => (
      <option key={index} value={element.code}>
       {element.name} ({element.code})
      </option>
    ));

    // getting medical aid plan data from dropdown json
    // const mediaclAidPlanOptions =
    //   dropdownData &&
    //   !isDropdownEmpty &&
    //   dropdownData.lk_medical_plan.map((element, index) => (
    //     <option key={index} value={element.lk_medical_plan_id}>
    //       {element.medical_plan}
    //     </option>
    //   ));

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    const systemRoleOptions = dropdownData &&
    !isDropdownEmpty &&
    dropdownData.role.filter((opt) => opt.role_id !== 1)
    .filter((opt)=>{
      if(Number(this.props.values.indvRelatedPartyRole) !== 3){
       return (opt.role_id !== 2)
      }else{
        return true
      }
    })
    .map((opt, index) => (
      <option key={index} value={opt.role_id}>
        {opt.role_name}
      </option>
    ));

    const patientRelationshipOptions = dropdownData &&
    !isDropdownEmpty &&
    dropdownData.lk_patient_relation.map((opt, index) => (
      <option key={index} value={opt.code}>
        {opt.patient_relation}
      </option>
    ));
   //console.log("this.props.values.assigned_roles", this.props.values.assigned_roles);
    const primarySystemRoleOptions = 
    dropdownData && dropdownData.role &&
    dropdownData.role.map((element, index) => {
     if(this.props.values.assigned_roles &&
      this.props.values.assigned_roles.length > 0 
      && this.props.values.assigned_roles.indexOf(element.role_id) > -1){
        return (
        <option key={index} value={element.role_id}>
          {element.role_name}
        </option>
        )
     }
    });
    //console.log("Role", this.props.values.indvRelatedPartyRole);

    return (
      <div className={style.individualInfoMainWrapper}>
        <div className={style.headingWrapper}>
          <div className="row">
            <div className="col-lg-12 intro-text">
              <h2>Step 2 : Contact Creation - Individual Info</h2>
              <p>
              Capture the Individual's details as requested on the form below. 
              Ensure that the Patient's email address is captured correctly as it will be used to send notifications 
              where applicable. For system access, select the Contact's title as Staff Member or Doctor and assign the 
              role they will be performing on the system.
              </p>
            </div>
          </div>
          <hr />
        </div>
        <div className="row">
          <div className="col-md-10 col-xl-6">
            <div className="custom-stepper">
              <div className={style.stepperWrapper}>
                <div className="custom-stepper">
                  <ul>
                    <li>
                      <h3 onClick={this.goBack}>1</h3>
                    </li>
                    <li>
                      <h3 className="active">2</h3>
                    </li>
                    <li>
                      <h3 onClick={this.goNext}>3</h3>
                    </li>
                    <li>
                      <h3 onClick={this.goNextStpe4}>4</h3>
                    </li>
                  </ul>
                </div>
                {/* <div className="custom-stepper">
                  <div className={style.stepperWrapper}>
                    <Stepper
                      steps={[
                        { label: "" },
                        { label: "" },
                        { label: "" },
                        { label: "" },
                      ]}
                      activeStep={0}
                      styleConfig={{
                        inactiveBgColor: "#fff",
                        activeBgColor: "#00467F",
                        inactiveTextColor: "#00467F",
                        activeTextColor: "#fff",
                        completedBgColor: "#fff",
                        completedTextColor: "#00467F",
                      }}
                      connectorStyleConfig={{
                        disabledColor: "#00467F33 ",
                        size: 2,
                      }}
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className={`form-controls-wrapper ${style.individualInfoFormWrapper}`}
        >
          <div className={style.relatedPartyRoleWrapper}>
            <h4>Select the Title of Contact</h4>
            <div className="row form-group">
              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                <label>
                  Title of the Contact <span className="mandatory">*</span>
                </label>
                <Field
                  as="select"
                  name="indvRelatedPartyRole"
                  onChange={(e)=>{
                    this.props.setFieldValue("indvRelatedPartyRole", e.target.value);
                    this.props.setFieldValue("assigned_roles", []);
                    this.props.setFieldValue("systemRoleParty", "");
                  }}
                  className={
                    "form-control" +
                    (this.props.errors.indvRelatedPartyRole &&
                    this.props.touched.indvRelatedPartyRole
                      ? " is-invalid"
                      : "")
                  }
                >
                  <option value="">Select a Role</option>
                  {roleOptions}
                </Field>
                {this.props.errors.indvRelatedPartyRole &&
                this.props.touched.indvRelatedPartyRole ? (
                  <div className={style.errMsg}>
                    {this.props.errors.indvRelatedPartyRole}
                  </div>
                ) : null}
              </div>
              {this.props.values.indvRelatedPartyRole == 5 && (
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label>
                    Choose a Professional Service
                    <span className="mandatory">*</span>
                  </label>
                  <Field
                    as="select"
                    name="indvProfessionalService"
                    className={
                      "form-control" +
                      (this.props.errors.indvProfessionalService &&
                      this.props.touched.indvProfessionalService
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="">Select a service</option>
                    {serviceOptions}
                  </Field>
                  {this.props.errors.indvProfessionalService &&
                  this.props.touched.indvProfessionalService ? (
                    <div className={style.errMsg}>
                      {this.props.errors.indvProfessionalService}
                    </div>
                  ) : null}
                </div>
              )}
              {((Number(this.props.values.indvRelatedPartyRole) === 3 || Number(this.props.values.indvRelatedPartyRole) === 10)
               && checkIfPermitted(Permissions.CREATE_SYSTEM_USERS) ) && (
               <React.Fragment>
                <div className="col-md-8 col-lg-6 col-xl-6">
                  <div className="form-group">
                    <label htmlFor="assigned_roles">
                      Assign System Roles</label>
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      name="assigned_roles"
                      onChange={(arr) => {
                        this.props.setFieldValue("assigned_roles", [...arr]);
                        if(arr.length === 0 || (arr.indexOf(this.props.values.systemRoleParty) === -1)){
                          this.props.setFieldValue("systemRoleParty", "");
                        }
                      }}
                      placeholder="Click here to select system roles"
                      value={this.props.values.assigned_roles}
                    >
                    {systemRoleOptions}
                    </Select>
                  </div>
                </div>
                  <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                      <label>
                        Choose primary system role {this.props.values.assigned_roles.length > 0 && (
                        <span className="mandatory">*</span>)}
                      </label>
                    <Field
                      as="select"
                      name="systemRoleParty"
                      disabled={this.props.values.assigned_roles.length === 0}
                      onChange={this.props.handleChange}
                      className={
                        "form-control" +
                        (this.props.values.assigned_roles.length > 0 && 
                          this.props.errors.systemRoleParty && this.props.touched.systemRoleParty
                          ? " is-invalid"
                          : "")
                      }
                    >
                      <option value="">Select a primary role</option>
                      {primarySystemRoleOptions}
                    </Field>   
                      {this.props.values.assigned_roles.length > 0 && 
                          this.props.errors.systemRoleParty && this.props.touched.systemRoleParty ? (
                        <div className={style.errMsg}>{this.props.errors.systemRoleParty}</div>
                      ) : null}
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>

          <h4>Enter the below details for the Contact</h4>
          <div className="row form-group">
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="title">
                Title <span className="mandatory">*</span>
              </label>
              <Field
                name="title"
                as="select"
                placeholder="Select Title"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.title && this.props.touched.title
                    ? " is-invalid"
                    : "")
                }
              >
                <option value="">Select Title</option>
                {titleOptions}
              </Field>
              {this.props.errors.title && this.props.touched.title ? (
                <div className={style.errMsg}>{this.props.errors.title}</div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="firstName">
                First Names <span className="mandatory">*</span>
              </label>
              <Field
                name="firstName"
                placeholder="First Names"
                maxLength="20"
                value={this.props.values.firstName}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.firstName && this.props.touched.firstName
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.firstName && this.props.touched.firstName ? (
                <div className={style.errMsg}>
                  {this.props.errors.firstName}
                </div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="lastName">
                Last Name <span className="mandatory">*</span>
              </label>
              <Field
                name="lastName"
                placeholder="Last Name"
                maxLength="20"
                value={this.props.values.lastName}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.lastName && this.props.touched.lastName
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.lastName && this.props.touched.lastName ? (
                <div className={style.errMsg}>{this.props.errors.lastName}</div>
              ) : null}
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="dateOfBirth">
                Date Of Birth
              </label>
              <DatePicker
                disabledDate={this.disabledDate}
                onChange={(date, dateString) => {
                  this.props.setFieldValue("dateOfBirth", dateString);
                }}
                placeholder="Date of birth"
                selected={moment(this.props.values.dateOfBirth)}
                className={
                  "form-control" +
                  (this.props.errors.dateOfBirth && this.props.touched.dateOfBirth
                    ? " is-invalid"
                    : "")
                }
                format="YYYY-MM-DD"
                defaultValue={
                  this.props.values.dateOfBirth
                    ? moment(this.props.values.dateOfBirth)
                    : ""
                }
               // onBlur={this.dateValidationMsg}
               onBlur={()=>{
                this.props.setFieldTouched("dateOfBirth", true)
              }}
              />
              {this.props.errors.dateOfBirth && this.props.touched.dateOfBirth ? (
                <div className={style.errMsg}>{this.props.errors.dateOfBirth}</div>
              ) : null}
              {/* <span className={style.errMsg}>{this.state.dateErr}</span> */}
            </div>

            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="gender">
                Gender <span className="mandatory">*</span>
              </label>
              <Field
                name="gender"
                as="select"
                placeholder="Gender"
                value={this.props.values.gender}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.gender && this.props.touched.gender
                    ? " is-invalid"
                    : "")
                }
              >
                <option value="">Select gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </Field>
              {this.props.errors.gender && this.props.touched.gender ? (
                <div className={style.errMsg}>{this.props.errors.gender}</div>
              ) : null}
            </div>

            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="passportNumber">ID/Passport Number</label>
              <Field
                name="passportNumber"
                placeholder="Passport Number"
                maxLength="20"
                value={this.props.values.passportNumber}
                onChange={this.props.handleChange}
                className="form-control"
              />
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="physicalAddress">Physical Address</label>
              <Field
                name="physicalAddress"
                placeholder="Physical Address"
                maxLength="50"
                value={this.props.values.physicalAddress}
                onChange={this.props.handleChange}
                className="form-control"
              />
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="postalAddress">Postal Address (Optional)</label>
              <Field
                name="postalAddress"
                placeholder="Postal Address"
                maxLength="50"
                value={this.props.values.postalAddress}
                onChange={this.props.handleChange}
                className="form-control"
              />
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="cellNumber">
                Contact Number <span className="mandatory">*</span>
              </label>
              <Field
                name="cellNumber"
                placeholder="Contact Number"
                maxLength="15"
                value={this.props.values.cellNumber}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.cellNumber && this.props.touched.cellNumber
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.cellNumber && this.props.touched.cellNumber ? (
                <div className={style.errMsg}>
                  {this.props.errors.cellNumber}
                </div>
              ) : null}
            </div>

            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="emailAddress">
                Email Address <span className="mandatory">*</span>
              </label>
              <Field
                name="emailAddress"
                placeholder="Email Address"
                value={this.props.values.emailAddress}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.emailAddress &&
                  this.props.touched.emailAddress
                    ? " is-invalid"
                    : "")
                }
                disabled={this.props.values.isEditMode ? true : false}
              />
              {this.props.errors.emailAddress &&
              this.props.touched.emailAddress ? (
                <div className={style.errMsg}>
                  {this.props.errors.emailAddress}
                </div>
              ) : null}
            </div>

            {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="mainMember">Main Member</label>
              <Field
                name="mainMember"
                placeholder="Main Member"
                maxLength="20"
                value={this.props.values.mainMember}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.mainMember &&
                  this.props.touched.mainMember
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.mainMember && this.props.touched.mainMember ? (
                <div className={style.errMsg}>{this.props.errors.mainMember}</div>
              ) : null}
            </div> */}
            {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="referringPractitioner">
                Referring Practitioner
              </label>
              <Field
                name="referringPractitioner"
                maxLength="20"
                placeholder="Referring Practitioner"
                value={this.props.values.referringPractitioner}
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.referringPractitioner &&
                  this.props.touched.referringPractitioner
                    ? " is-invalid"
                    : "")
                }
              />
              {this.props.errors.referringPractitioner && this.props.touched.referringPractitioner ? (
                <div className={style.errMsg}>{this.props.errors.referringPractitioner}</div>
              ) : null}
            </div> */}
            {this.props.values.indvRelatedPartyRole == "3" && (
            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
              <label htmlFor="room_id">
                Room <span className="mandatory">*</span>
              </label>
              <Field
                name="room_id"
                as="select"
                placeholder="Select Room"
                onChange={this.props.handleChange}
                className={
                  "form-control" +
                  (this.props.errors.room_id && this.props.touched.room_id
                    ? " is-invalid"
                    : "")
                }
              >
                <option value="">Select Room</option>
                {roomOptions}
              </Field>
              {this.props.errors.room_id && this.props.touched.room_id ? (
                <div className={style.errMsg}>{this.props.errors.room_id}</div>
              ) : null}
            </div>)}
          </div>

          {/* <div class="col-md-12 d-flex flex-wrap mb-3">
    <label class="mr-3">Patient Type:</label>
    <div>
        <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" class="custom-control-input" id="privatePatient" name="patientType" value="privatePatient" checked="">
            <label class="custom-control-label IndividualInfo_patientType__2Ue_I" for="privatePatient">Private Patient</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" class="custom-control-input" id="medicalAid" name="patientType" value="medicalAid">
            <label class="custom-control-label IndividualInfo_patientType__2Ue_I" for="medicalAid">Medical Aid Patient</label>
        </div>
    </div>
</div> */}

          {/* Hide and show div based on patient role */}
          {(this.props.values.indvRelatedPartyRole === "4" ||
              this.props.values.indvRelatedPartyRole === 4) && (
            <div className="row form-group">
              <div className="col-md-12 d-flex flex-wrap mb-3">
                <label className="mr-3">Patient Type:</label>
                <div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="privatePatient"
                      name="patientType"
                      checked={
                        this.props.values.patientType === "privatePatient"
                      }
                      onChange={this.props.handleChange}
                      value="privatePatient"
                    />
                    <label
                      className={`custom-control-label ${style.patientType}`}
                      htmlFor="privatePatient"
                    >
                      Private Patient
                    </label>
                  </div>
                  <div className="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      className="custom-control-input"
                      id="medicalAid"
                      name="patientType"
                      checked={this.props.values.patientType === "medicalAid"}
                      onChange={this.props.handleChange}
                      value="medicalAid"
                    />
                    <label
                      className={`custom-control-label ${style.patientType}`}
                      htmlFor="medicalAid"
                    >
                      Medical Aid Patient
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Hide and show div based on patient type and medical aid choice */}
          {this.props.values.patientType === "medicalAid" &&
            (this.props.values.indvRelatedPartyRole === "4" ||
              this.props.values.indvRelatedPartyRole === 4) && (
              <div className="row form-group" id="medical-aid-wrapper">
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="medicalAidScheme">Medical Aid Scheme{" "}<span className="mandatory">*</span></label>
                  {/* <Field
                    as="select"
                    name="medicalAidScheme"
                    onChange={(e)=>{
                      this.handleMedSelectChange(e);
                      this.props.handleChange(e);
                      if(this.props.values.medicalAidPlan){
                        this.props.setFieldValue("medicalAidPlan", "");
                      }
                      if(this.props.values.medicalAidPlanOption){
                        this.props.setFieldValue("medicalAidPlanOption", "");
                      }
                      if(this.props.values.medicalAidPlanSubOption){
                        this.props.setFieldValue("medicalAidPlanSubOption", "");
                      }
                    }}
                    className={
                      "form-control" +
                      (this.props.errors.medicalAidScheme &&
                      this.props.touched.medicalAidScheme
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="">Select Medical Aid Scheme</option>
                    {mediaclAidSchemeOptions}
                  </Field> */}
                  <Select
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      name="medicalAidScheme"
                      placeholder="Search and select scheme"
                      optionFilterProp="children"
                      onBlur={()=>{
                        this.props.setFieldTouched("medicalAidScheme", true)
                      }}
                      onChange={(value)=>{
                        this.handleMedSchemeSelectChange(value, "medicalAidScheme");
                        //this.props.handleChange(e);
                        if(this.props.values.medicalAidPlan){
                          this.props.setFieldValue("medicalAidPlan", "");
                        }
                        if(this.props.values.medicalAidPlanOption){
                          this.props.setFieldValue("medicalAidPlanOption", "");
                        }
                        if(this.props.values.medicalAidPlanSubOption){
                          this.props.setFieldValue("medicalAidPlanSubOption", "");
                        }
                      }}
                      filterOption={(input, option) =>
                        option.children.toString()
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      className={
                        (this.props.errors.medicalAidScheme &&
                        this.props.touched.medicalAidScheme
                          ? " is-invalid"
                          : "")
                      }
                      value={this.props.values.medicalAidScheme || undefined}
                    >
                      {schemesDropDownListData &&
                        schemesDropDownListData.map((element, index) => (
                          <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                            {element.name} ({element.code})
                          </Option>
                        ))}
                    </Select>
                  {this.props.errors.medicalAidScheme && 
                  this.props.touched.medicalAidScheme ? (
                    <div className={style.errMsg}>
                      {this.props.errors.medicalAidScheme}</div>
                  ) : null}
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="medicalAidPlan">Medical Aid Plan{" "}<span className="mandatory">*</span></label>
                  {/* <Field
                    as="select"
                    name="medicalAidPlan"
                    disabled={!this.props.values.medicalAidScheme}
                    onChange={(e)=>{
                      this.handleMedSelectChange(e);
                      this.props.handleChange(e);
                      if(this.props.values.medicalAidPlanOption){
                        this.props.setFieldValue("medicalAidPlanOption", "");
                      }
                      if(this.props.values.medicalAidPlanSubOption){
                        this.props.setFieldValue("medicalAidPlanSubOption", "");
                      }
                    }}
                    className={
                      "form-control" +
                      (this.props.errors.medicalAidPlan &&
                      this.props.touched.medicalAidPlan
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="">Select Medical Aid Plan</option>
                    {mediaclAidSchemePlanOptions}
                  </Field> */}
                  <Select
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      name="medicalAidPlan"
                      disabled={!this.props.values.medicalAidScheme}
                      placeholder="Search and select scheme plan"
                      optionFilterProp="children"
                      onBlur={()=>{
                        this.props.setFieldTouched("medicalAidPlan", true)
                      }}
                      onChange={(value)=>{
                        this.handleMedSchemeSelectChange(value, "medicalAidPlan");
                        //this.props.handleChange(e);
                        if(this.props.values.medicalAidPlanOption){
                          this.props.setFieldValue("medicalAidPlanOption", "");
                        }
                        if(this.props.values.medicalAidPlanSubOption){
                          this.props.setFieldValue("medicalAidPlanSubOption", "");
                        }
                      }}
                      filterOption={(input, option) =>
                        option.children.toString()
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      className={
                        (this.props.errors.medicalAidPlan &&
                        this.props.touched.medicalAidPlan
                          ? " is-invalid"
                          : "")
                      }
                      value={this.props.values.medicalAidPlan || undefined}
                    >
                      {schemesPlanDropDownListData &&
                        schemesPlanDropDownListData.map((element, index) => (
                          <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                            {element.name} ({element.code})
                          </Option>
                        ))}
                    </Select>
                  {this.props.errors.medicalAidPlan && 
                  this.props.touched.medicalAidPlan ? (
                    <div className={style.errMsg}>
                      {this.props.errors.medicalAidPlan}</div>
                  ) : null}
                </div>
                { mediaclAidSchemePlanOptions && 
                mediaclAidSchemePlanOptions.length > 0 && 
                mediaclAidSchemePlanOptionsOptions &&
                mediaclAidSchemePlanOptionsOptions.length > 0 && 
                (<div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="medicalAidPlanOption">Medical Aid Plan Options{" "}
                  {/* <span className="mandatory">*</span> */}
                  </label>
                  {/* <Field
                    as="select"
                    name="medicalAidPlanOption"
                    disabled={!this.props.values.medicalAidPlan}
                    onChange={(e)=>{
                      this.handleMedSelectChange(e);
                      this.props.handleChange(e);
                      if(this.props.values.medicalAidPlanSubOption){
                        this.props.setFieldValue("medicalAidPlanSubOption", "");
                      }
                    }}
                    className={
                      "form-control" +
                      (this.props.errors.medicalAidPlanOption &&
                      this.props.touched.medicalAidPlanOption
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="">Select Medical Aid Plan Options</option>
                    {mediaclAidSchemePlanOptionsOptions}
                  </Field> */}
                  <Select
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      disabled={!this.props.values.medicalAidPlan}
                      name="medicalAidPlanOption"
                      placeholder="Search and select scheme plan option"
                      optionFilterProp="children"
                      onBlur={()=>{
                        this.props.setFieldTouched("medicalAidPlanOption", true)
                      }}
                      onChange={(value)=>{
                        this.handleMedSchemeSelectChange(value, "medicalAidPlanOption");
                        //this.props.handleChange(e);
                        if(this.props.values.medicalAidPlanSubOption){
                          this.props.setFieldValue("medicalAidPlanSubOption", "");
                        }
                      }}
                      filterOption={(input, option) =>
                        option.children.toString()
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      className={
                        (this.props.errors.medicalAidPlanOption &&
                        this.props.touched.medicalAidPlanOption
                          ? " is-invalid"
                          : "")
                      }
                      value={this.props.values.medicalAidPlanOption || undefined}
                    >
                      {schemesPlanOptionsDropDownListData &&
                        schemesPlanOptionsDropDownListData.map((element, index) => (
                          <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                            {element.name} ({element.code})
                          </Option>
                        ))}
                    </Select>
                  {this.props.errors.medicalAidPlanOption && 
                  this.props.touched.medicalAidPlanOption ? (
                    <div className={style.errMsg}>
                      {this.props.errors.medicalAidPlanOption}</div>
                  ) : null}
                </div>)}
                
                {mediaclAidSchemePlanOptions && 
                mediaclAidSchemePlanOptions.length > 0 &&
                mediaclAidSchemePlanOptionsOptions &&
                mediaclAidSchemePlanOptionsOptions.length > 0 &&
                mediaclAidSchemePlanSubOptionsOptions && 
                mediaclAidSchemePlanSubOptionsOptions.length > 0 && (
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="medicalAidPlanSubOption">Medical Aid Plan Sub Options{" "}
                  {/* <span className="mandatory">*</span> */}
                  </label>
                  {/* <Field
                    as="select"
                    name="medicalAidPlanSubOption"
                    disabled={!this.props.values.medicalAidPlanOption}
                    onChange={this.props.handleChange}
                    className={
                      "form-control" +
                      (this.props.errors.medicalAidPlanSubOption &&
                      this.props.touched.medicalAidPlanSubOption
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="">Select Medical Aid Plan Sub option</option>
                     {mediaclAidSchemePlanSubOptionsOptions} 
                  </Field> */}
                  <Select
                      showSearch={true}
                      showArrow={true}
                      allowClear={true}
                      disabled={!this.props.values.medicalAidPlanOption}
                      name="medicalAidPlanSubOption"
                      placeholder="Search and select scheme plan suboption"
                      optionFilterProp="children"
                      onBlur={()=>{
                        this.props.setFieldTouched("medicalAidPlanSubOption", true)
                      }}
                      onChange={(value)=>{
                        this.handleMedSchemeSelectChange(value, "medicalAidPlanSubOption");
                        //this.props.handleChange(e);
                      }}
                      filterOption={(input, option) =>
                        option.children.toString()
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      className={
                        (this.props.errors.medicalAidPlanSubOption &&
                        this.props.touched.medicalAidPlanSubOption
                          ? " is-invalid"
                          : "")
                      }
                      value={this.props.values.medicalAidPlanSubOption || undefined}
                    >
                      {schemesPlanSubOptionsDropDownListData &&
                        schemesPlanSubOptionsDropDownListData.map((element, index) => (
                          <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                            {element.name} ({element.code})
                          </Option>
                        ))}
                    </Select>
                  {this.props.errors.medicalAidPlanSubOption && 
                  this.props.touched.medicalAidPlanSubOption ? (
                    <div className={style.errMsg}>
                      {this.props.errors.medicalAidPlanSubOption}</div>
                  ) : null}
                </div>)}
                {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="memberFullName">
                    Member Full Name{" "}<span className="mandatory">*</span></label>
                  <Field
                    name="memberFullName"
                    maxLength="20"
                    placeholder="Member Full Name"
                    value={this.props.values.memberFullName}
                    onChange={this.props.handleChange}
                    className={
                      "form-control" +
                      (this.props.errors.memberFullName &&
                      this.props.touched.memberFullName
                        ? " is-invalid"
                        : "")
                    }
                  />
                  {this.props.errors.memberFullName && 
                  this.props.touched.memberFullName ? (
                    <div className={style.errMsg}>
                      {this.props.errors.memberFullName}</div>
                  ) : null}
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="memberSurname">
                    Member Surname{" "}<span className="mandatory">*</span></label>
                  <Field
                    name="memberSurname"
                    maxLength="20"
                    placeholder="Member Surname"
                    value={this.props.values.memberSurname}
                    onChange={this.props.handleChange}
                    className={
                      "form-control" +
                      (this.props.errors.memberSurname &&
                      this.props.touched.memberSurname
                        ? " is-invalid"
                        : "")
                    }
                  />
                  {this.props.errors.memberSurname && 
                  this.props.touched.memberSurname ? (
                    <div className={style.errMsg}>
                      {this.props.errors.memberSurname}</div>
                  ) : null}
                </div> */}
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="medicalIDNumber">
                    Medical ID/Passport Number{" "}<span className="mandatory">*</span></label>
                  <Field
                    name="medicalIDNumber"
                    maxLength="20"
                    placeholder="Medical ID/Passport Number"
                    value={this.props.values.medicalIDNumber}
                    onChange={this.props.handleChange}
                    className={
                      "form-control" +
                      (this.props.errors.medicalIDNumber &&
                      this.props.touched.medicalIDNumber
                        ? " is-invalid"
                        : "")
                    }
                  />
                  {this.props.errors.medicalIDNumber && 
                  this.props.touched.medicalIDNumber ? (
                    <div className={style.errMsg}>
                      {this.props.errors.medicalIDNumber}</div>
                  ) : null}
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="medicalAidNumber">
                    Membership Number{" "}(Primary)<span className="mandatory">*</span></label>
                  <Field
                    name="medicalAidNumber"
                    maxLength="20"
                    placeholder="Medical Aid Number"
                    value={this.props.values.medicalAidNumber}
                    onChange={this.props.handleChange}
                    className={
                      "form-control" +
                      (this.props.errors.medicalAidNumber &&
                      this.props.touched.medicalAidNumber
                        ? " is-invalid"
                        : "")
                    }
                  />
                  {this.props.errors.medicalAidNumber && 
                  this.props.touched.medicalAidNumber ? (
                    <div className={style.errMsg}>
                      {this.props.errors.medicalAidNumber}</div>
                  ) : null}
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                  <label htmlFor="patientRelationship">Relationship To Main Member{" "}<span className="mandatory">*</span></label>
                  <Field
                    as="select"
                    name="patientRelationship"
                    onChange={this.props.handleChange}
                    className={
                      "form-control" +
                      (this.props.errors.patientRelationship &&
                      this.props.touched.patientRelationship
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option value="">Select Relationship</option>
                     {patientRelationshipOptions}
                  </Field>
                  {this.props.errors.patientRelationship && 
                  this.props.touched.patientRelationship ? (
                    <div className={style.errMsg}>
                      {this.props.errors.patientRelationship}</div>
                  ) : null}
                </div>
              </div>
            )}

          <div className="row form-group">
            <div className="col-md-12 d-flex flex-wrap mb-3">
              <label htmlFor="communication" className="mr-3">
                Preferred Method of Communication{" "}
              </label>
              <div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="sms"
                    name="communication"
                    checked={this.props.values.communication === "sms"}
                    onChange={this.props.handleChange}
                    value="sms"
                  />
                  <label className="custom-control-label" htmlFor="sms">
                    SMS
                  </label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    className="custom-control-input"
                    id="email"
                    name="communication"
                    checked={this.props.values.communication === "email"}
                    onChange={this.props.handleChange}
                    value="email"
                  />
                  <label className="custom-control-label" htmlFor="email">
                    Email
                  </label>
                </div>
              </div>
            </div>
          </div>
          {/* {Hide SA Id section start} */}
          {/* <div className="row">
            <div className="col-md-12">
              <div className={`form-group ${style.IdNumberWrapper}`}>
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="southAId"
                    name="southAId"
                    checked={this.props.values.southAId}
                    onChange={this.props.handleChange}
                  />
                  <label className="custom-control-label" htmlFor="southAId">
                    Capture South African ID Number
                  </label>
                </div>
              </div>
              {this.props.values.southAId === true && (
                <div className="row form-group">
                  <div className="col-md-3">
                    <Field
                      name="IdNumber"
                      placeholder="ID Number"
                      className="form-control"
                      value={this.props.values.IdNumber}
                      onChange={this.props.handleChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div> */}
          {/* {Hide SA Id section start} */}
          <hr className={style.formBottomLine} />
          {Object.keys(this.props.errors).length > 0 &&
            this.state.nextClicked && (
              <div className="text-danger">
                Please fill all mandatory fields!
              </div>
            )}
          <div
            className={` d-flex
              justify-content-between
              flex-column-reverse
              flex-md-row
              align-items-center ${style.btnWrapper}`}
          >
            <button
              type="button"
              className="btn form-primary-btn mb-3"
              onClick={this.props.navigateBack}
              disabled={this.props.pageIndex === 0}
            >
              Back
            </button>
            <button
              type="button"
              className="btn form-primary-btn"
              onClick={() => {
                this.props.navigateNext();
                this.setState({ nextClicked: true });
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    roomDropDownListData: state.roomDropDownList,
    schemesData: state.schemes,
    schemesPlanData: state.schemesPlan,
    schemesPlanOptionsData: state.schemesPlanOptions,
    schemesPlanSubOptionsData: state.schemesPlanSubOptions
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchRoomDropDownListing: () => dispatch(fetchRoomDropDownListing()),
    fetchMedSchemes: (scheme) => dispatch(fetchMedSchemes(scheme)),
    fetchMedSchemesPlan: (scheme_code) => dispatch(fetchMedSchemesPlan(scheme_code)),
    fetchMedSchemesPlanOptions: (plan_code) => dispatch(fetchMedSchemesPlanOptions(plan_code)),
    fetchMedSchemesPlanSubOptions: (plan_option_code) => dispatch(fetchMedSchemesPlanSubOptions(plan_option_code)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndividualInfo);
